import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  CircularProgress,
} from "@mui/material";

interface ButtonProps extends MuiButtonProps {
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  disabled,
  loading = false,
  ...props
}) => (
  <MuiButton
    variant="contained"
    color="primary"
    sx={{ minWidth: 110 }}
    {...props}
    disabled={loading || disabled}
  >
    {loading ? <CircularProgress size={"25px"} /> : props.children}
  </MuiButton>
);

export default Button;
